module.exports = __webpack_public_path__ + "static/media/value-added.6812547d.png";